import { Component, computed, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Course } from '../../../../api/course/course.model';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { canRegisterForCourse } from '../../../../api/course/course.util';
import { FrontendHeaderComponent } from '../../../_layout/frontend-header/frontend-header.component';
import { i18nRouterLinkDirective } from '../../../../util/router/i18n-router-link.directive';

@Component({
  selector: 'app-courses-header',
  standalone: true,
  imports: [
    RouterModule,
    MatTooltipModule,
    MatChipsModule,
    FrontendHeaderComponent,
    i18nRouterLinkDirective,
  ],
  templateUrl: './course-catalogue-header.component.html',
})
export class CourseCatalogueHeaderComponent {
  course = input<Course>();
  navigate = output<string>();
  protected readonly label = computed(() => this.course()?.name ?? '');

  isCourseAvailable = computed(() => {
    const course = this.course();
    return course && canRegisterForCourse(course);
  });
  tooltipText = computed(() => {
    return this.isCourseAvailable() ? '' : $localize`Registrations closed`;
  });
}
